module.exports = __webpack_public_path__ + "static/Karla-Regular-fd3f938a23d57da8894c8aa0e85adf3f.ttf";